import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e5660a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "spinner_qM83",
  cx: "4",
  cy: "12",
  r: "3",
  fill: "currentColor"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "spinner_qM83 spinner_oXPr",
  cx: "12",
  cy: "12",
  r: "3",
  fill: "currentColor"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "spinner_qM83 spinner_ZTLf",
  cx: "20",
  cy: "12",
  r: "3",
  fill: "currentColor"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'DotLoader',
  props: {
  size: {
    type: String,
    default: '24',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_5, 8, _hoisted_1))
}
}

})